/**
 * Fiscal year formatting only. Business logic (FY/quarter for a date, ranges) lives on the API.
 * Use fiscalYearService for current, quarter-range, and evaluate.
 */

/**
 * Formats a fiscal year and quarter as a string (e.g., "FY 2024 Q3")
 */
export function formatFiscalYearQuarter(fiscalYear: number, quarter: number): string {
  return `FY ${fiscalYear} Q${quarter}`;
}

/**
 * Gets a suggested name for a review cycle based on fiscal year and quarter
 */
export function getSuggestedReviewCycleName(fiscalYear: number, quarter: number): string {
  return `${formatFiscalYearQuarter(fiscalYear, quarter)} Review`;
}
